// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root {
    /* Pink */
    --pink-background:rgba(23, 8, 21, 1);
    --pink-tiles:rgba(136, 28, 120, 0.03);
    --pink-check:rgba(224, 136, 211, 0.114);
    --pink-text:rgba(244, 227, 242, 1);
    --pink-primary:rgba(224, 136, 211, 1);
    --pink-secondary:rgba(136, 28, 120, 1);
    --pink-accent:rgba(221, 37, 193, 1);
    --pink-select:rgba(221, 37, 193, 0.311);
    --pink-todo:rgba(221, 37, 193, 0.07);
    --pink-form-background:rgba(75, 2, 64, 0.819);
    --pink-form-primary:rgba(224, 136, 211, 1);
    --pink-form-seconday:rgba(191, 36, 167, 1);

}

.pink {
    --background:var(--pink-background);
    --tiles:var(--pink-tiles);
    --check:var(--pink-check);
    --text:var(--pink-text);
    --primary:var(--pink-primary);
    --secondary:var(--pink-secondary);
    --accent:var(--pink-accent);
    --select:var(--pink-select);
    --todo:var(--pink-todo);
    --form-background:var(--pink-form-background);
    --form-primary:var(--pink-form-primary);
    --form-secondary:var(--pink-form-seconday)
}`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":";;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,qCAAqC;IACrC,uCAAuC;IACvC,kCAAkC;IAClC,qCAAqC;IACrC,sCAAsC;IACtC,mCAAmC;IACnC,uCAAuC;IACvC,oCAAoC;IACpC,6CAA6C;IAC7C,0CAA0C;IAC1C,0CAA0C;;AAE9C;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,6CAA6C;IAC7C,uCAAuC;IACvC;AACJ","sourcesContent":["\r\n\r\n:root {\r\n    /* Pink */\r\n    --pink-background:rgba(23, 8, 21, 1);\r\n    --pink-tiles:rgba(136, 28, 120, 0.03);\r\n    --pink-check:rgba(224, 136, 211, 0.114);\r\n    --pink-text:rgba(244, 227, 242, 1);\r\n    --pink-primary:rgba(224, 136, 211, 1);\r\n    --pink-secondary:rgba(136, 28, 120, 1);\r\n    --pink-accent:rgba(221, 37, 193, 1);\r\n    --pink-select:rgba(221, 37, 193, 0.311);\r\n    --pink-todo:rgba(221, 37, 193, 0.07);\r\n    --pink-form-background:rgba(75, 2, 64, 0.819);\r\n    --pink-form-primary:rgba(224, 136, 211, 1);\r\n    --pink-form-seconday:rgba(191, 36, 167, 1);\r\n\r\n}\r\n\r\n.pink {\r\n    --background:var(--pink-background);\r\n    --tiles:var(--pink-tiles);\r\n    --check:var(--pink-check);\r\n    --text:var(--pink-text);\r\n    --primary:var(--pink-primary);\r\n    --secondary:var(--pink-secondary);\r\n    --accent:var(--pink-accent);\r\n    --select:var(--pink-select);\r\n    --todo:var(--pink-todo);\r\n    --form-background:var(--pink-form-background);\r\n    --form-primary:var(--pink-form-primary);\r\n    --form-secondary:var(--pink-form-seconday)\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
